import { apiEndpoints } from './api';

// Types
export interface SftpSystemSettings {
  enabled: boolean;
  timerPeriodString: string;
}

export interface UpdateSftpSystemSettingsInput {
  enabled: boolean;
  timerPeriodString: string;
}

export interface SftpSystemSettingsPayload {
  state?: SftpSystemSettings;
  errors?: Array<{
    message: string;
  }>;
}

// GraphQL Documents
const GET_SFTP_SYSTEM_SETTINGS = `
  query GetSftpSystemSettings {
    sftpSystemSettings {
      enabled
      timerPeriodString
    }
  }
`;

const UPDATE_SFTP_SYSTEM_SETTINGS = `
  mutation UpdateSftpSystemSettings($input: UpdateSftpSystemSettingsInput!) {
    updateSftpSystemSettings(input: $input) {
      state {
        enabled
        timerPeriodString
      }
      errors {
        message
      }
    }
  }
`;

// RTK Query API
export const sftpSystemSettingsApi = apiEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    getSftpSystemSettings: builder.query<SftpSystemSettings, void>({
      query: () => ({
        document: GET_SFTP_SYSTEM_SETTINGS,
      }),
      transformResponse: (response: any) => {
        // The response structure might be different depending on the GraphQL client
        // Check if data is already at the top level or nested
        const result = response.sftpSystemSettings || response.data?.sftpSystemSettings;
        return result;
      },
      providesTags: ['SftpSystemSettings'],
    }),

    updateSftpSystemSettings: builder.mutation<
      SftpSystemSettingsPayload,
      UpdateSftpSystemSettingsInput
    >({
      query: (input) => ({
        document: UPDATE_SFTP_SYSTEM_SETTINGS,
        variables: { input },
      }),
      transformResponse: (response: any) => {
        // Check both possible response structures
        const result = response.updateSftpSystemSettings || response.data?.updateSftpSystemSettings;
        return result;
      },
      invalidatesTags: ['SftpSystemSettings'],
      // Optimistic update
      async onQueryStarted(input, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          sftpSystemSettingsApi.util.updateQueryData('getSftpSystemSettings', undefined, (draft) => {
            Object.assign(draft, input);
          })
        );
        try {
          const { data } = await queryFulfilled;
          // If there are errors, revert the optimistic update
          if (data.errors && data.errors.length > 0) {
            patchResult.undo();
          }
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetSftpSystemSettingsQuery,
  useUpdateSftpSystemSettingsMutation,
} = sftpSystemSettingsApi;